import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';
import api, { getErrorMessage } from '../api/client';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try {
      const stored = localStorage.getItem('avm_user');
      return stored ? JSON.parse(stored) : null;
    } catch {
      return null;
    }
  });
  const [loading, setLoading] = useState(false);
  const [authError, setAuthError] = useState('');

  // URL'de session_expired parametresi varsa uyarı göster
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('reason') === 'session_expired') {
      setAuthError('Oturumunuzun süresi doldu. Lütfen tekrar giriş yapın.');
      window.history.replaceState({}, '', '/login');
    }
  }, []);

  const login = useCallback(async (email, password) => {
    setLoading(true);
    setAuthError('');
    try {
      const { data } = await api.post('/auth/login', {
        email:    email.trim().toLowerCase(),
        password,
      });

      const { token, user: userData } = data.data;
      localStorage.setItem('avm_token', token);
      localStorage.setItem('avm_user',  JSON.stringify(userData));
      setUser(userData);
      return userData;
    } catch (err) {
      const msg = getErrorMessage(err);
      setAuthError(msg);
      throw new Error(msg);
    } finally {
      setLoading(false);
    }
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem('avm_token');
    localStorage.removeItem('avm_user');
    setUser(null);
    setAuthError('');
  }, []);

  const isAdmin        = user?.role === 'super_admin';
  const isCustomerAdmin = user?.role === 'customer_admin';
  const isViewer       = user?.role === 'customer_viewer';

  /**
   * Rol bazlı ana sayfa yolu
   */
  const homePath = () => {
    if (!user) return '/login';
    if (user.role === 'super_admin') return '/admin';
    return '/dashboard';
  };

  return (
    <AuthContext.Provider value={{
      user, login, logout, loading, authError, setAuthError,
      isAdmin, isCustomerAdmin, isViewer, homePath,
    }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth, AuthProvider içinde kullanılmalıdır');
  return ctx;
};
